import { gql } from '@apollo/client'

const GET_CONTENTS_AGGREGATIONS = gql`
  query contentsAggregations(
    $arguments: GetContents!
    $pagination: Pagination!
  ) {
    contents(arguments: $arguments, pagination: $pagination) {
      aggregations {
        count
        themes {
          name
          count
        }
        celebrities {
          name
          count
        }
      }
      pagination {
        next
        pages
        previous
      }
    }
  }
`

export default GET_CONTENTS_AGGREGATIONS
